import {Component} from '@angular/core';

@Component({
  selector: 'cm-report-builder-saved-reports',
  templateUrl: './report-builder-saved-reports.component.html'
})
export class ReportBuilderSavedReportsComponent {
}
